import { wrapUseRoutes } from "@sentry/react"
import { useRoutes } from "react-router-dom"
import routes from "./routes/main.routes"
const useSentryRoutes = wrapUseRoutes(useRoutes)
function App() {
  return useSentryRoutes(routes as any)
}

export default App
